export default function Advertising() {
  return (
    <div className="smm-page" style={{ padding: '2rem' }}>
      <h1 className="smm-page-title">Advertising</h1>
      <div className="smm-card" style={{ padding: '2rem', textAlign: 'center', color: 'var(--smm-text-muted, #888)' }}>
        <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>Advertising management is coming soon.</p>
        <p style={{ fontSize: '0.9rem' }}>
          This section will allow you to manage ad campaigns across connected platforms
          including LinkedIn Ads, Google Ads, TikTok Ads, and Pinterest Ads.
        </p>
      </div>
    </div>
  )
}
